import { RouteGuard } from "@/components/auth/route-guard";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/(profile)/profile")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RouteGuard>
      <div className="p-6 w-full">
        <Link to="/dashboard" className="flex items-center gap-2">
          <ArrowLeft className="size-4" />
          Back
        </Link>
        <div className="p-16">
          <Outlet />
        </div>
      </div>
    </RouteGuard>
  );
}
